









































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import AcademicTitle from '../../../models/academic/academicTitle.model';

@Component
export default class AcademicTitleAdd extends GenericAdd<AcademicTitle> {
  constructor() {
    super();
    this.controller = "AcademicTitle";
    this.model = new AcademicTitle();
  }
}
